import React from "react"
import PropTypes from "prop-types"
import { StyledLabel } from "./styles"

const Label = ({ children, invalid, simpleForm }) => (
  <StyledLabel invalid={invalid} simpleForm={simpleForm}>
    {children}
  </StyledLabel>
)

Label.propTypes = {
  children: PropTypes.node.isRequired,
  invalid: PropTypes.bool
}

Label.defaultProps = {
  invalid: false
}

export default Label
